import Navbar from "src/components/Landing/Navbar";
import { useEffect, useState } from "react";
import courses from "../data/courses.json";
import {
  Link,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import { IBlog, Video } from "src/types";
import APIService from "src/services/Api";
import process from "process";
import { AiOutlineLike } from "react-icons/ai";
import { ImSpinner9 } from "react-icons/im";
import { classNames, getSlug, getSubString } from "src/helpers/mixins";
import CardWall from "src/components/Dashboard/CardWall";
import { useAppStateContext } from "src/auth/AppStateContext";
import { getImageCourse } from "src/components/Academy/AcademyList";
import { UseAuth } from "src/auth/AuthContext";

const NewsHomePage = () => {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const [videos, setVideos] = useState<Video[]>([]);
  const [selectedVideo, setSelectedVideo] = useState<Video | null>(null);
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
  const [isLikingVideo, setIsLikingVideo] = useState(false);

  /* const { t } = useTranslation(); */

  const { blogs, fetchBlogs } = useAppStateContext();
  const { isAuthenticated } = UseAuth();

  const scrollToNews = () => {
    const newsSection = document.getElementById('news-section');
    if (newsSection) {
      newsSection.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  const scrollToVideos = () => {
    const videosSection = document.getElementById('videos-section');
    if (videosSection) {
      videosSection.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  const openVideoModal = async (video: Video) => {
    setSelectedVideo(video);
    setIsVideoModalOpen(true);
    
    // Actualizar vistas del video
    try {
      await APIService.videoUpdateViews({ type: 'view', videoId: video.id });
      // Actualizar el contador de vistas en el estado local
      setVideos(prevVideos => 
        prevVideos.map(v => 
          v.id === video.id ? { ...v, views: Number(v.views) + 1 } : v
        )
      );
    } catch (error) {
      console.error('Error updating video views:', error);
    }
  };

  const closeVideoModal = () => {
    setSelectedVideo(null);
    setIsVideoModalOpen(false);
  };

  const handleVideoLike = async () => {
    if (!selectedVideo || isLikingVideo) return;
    
    setIsLikingVideo(true);
    try {
      await APIService.videoLike({ videoId: selectedVideo.id });
      
      // Actualizar likes en el estado local
      setSelectedVideo(prev => prev ? { ...prev, likes: Number(prev.likes) + 1 } : null);
      setVideos(prevVideos => 
        prevVideos.map(v => 
          v.id === selectedVideo.id ? { ...v, likes: Number(v.likes) + 1 } : v
        )
      );
    } catch (error) {
      console.error('Error liking video:', error);
    } finally {
      setIsLikingVideo(false);
    }
  };
 
  const fetchVideos = async () => {
    setLoading(true);

    await APIService.getToken();
    const res = await APIService.videoList({type:'normal',status:'active'});
    let videos = res?.data?.data?.videos as Video[];
      fetchBlogs();

    setVideos(videos);
    setLoading(false);
  };

  /*   const handleVisit = (id: string) => {
    navigate(`/videos/${id}`);
  }; */

  useEffect(() => {
    fetchVideos();
  }, []);

  
 
 

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
      <Navbar />
      
              {/* Hero Section */}
        <section className="relative pt-6 pb-16 bg-gradient-to-r from-blue-600 via-purple-600 to-indigo-700">
          <div className="absolute inset-0 bg-black opacity-10"></div>
          <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center">
              <div className="text-4xl md:text-1xl font-bold text-black mb-6">
                Intercambios Sin Fronteras
              </div>
              <p className="text-xl md:text-2xl text-blue-100 mb-8 max-w-3xl mx-auto">
                {location.pathname.includes("/videos") 
                  ? "Descubre los mejores videos educativos y contenido audiovisual de nuestra plataforma"
                  : location.pathname.includes("/blog")
                  ? "Mantente informado con las últimas noticias, artículos y contenido exclusivo"
                  : "Descubre las últimas noticias, videos y contenido exclusivo de nuestra plataforma"
                }
              </p>
                            <div className="flex justify-center space-x-4">
                <button 
                  onClick={
                    location.pathname.includes("/blog") ? scrollToNews : 
                    location.pathname.includes("/videos") ? scrollToVideos : 
                    undefined
                  }
                  className="bg-white text-blue-600 px-8 py-3 rounded-full font-semibold hover:bg-blue-50 transition-all duration-300 shadow-lg"
                >
                  {location.pathname.includes("/videos") 
                    ? "Explorar Videos"
                    : location.pathname.includes("/blog")
                    ? "Leer Noticias"
                    : "Explorar Contenido"
                  }
                </button>
                {isAuthenticated ? (
                  <button 
                    onClick={() => navigate('/inicio')}
                    className="border-2 border-black text-black px-8 py-3 rounded-full font-semibold hover:bg-white hover:text-blue-600 transition-all duration-300"
                  >
                    Ir al Dashboard
                  </button>
                ) : (
                  <button 
                    onClick={() => navigate('/')}
                    className="border-2 border-black text-black px-8 py-3 rounded-full font-semibold hover:bg-white hover:text-blue-600 transition-all duration-300"
                  >
                    Iniciar Sesión
                  </button>
                )}
        </div>
        </div>
          </div>
        </section>

      {/* Featured Courses Grid - Smaller version */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-8">
        <div className="mb-8">
          <h3 className="text-sm  font-medium text-gray-600 mb-4 text-center">
            Cursos Destacados
          </h3>
          <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
            {courses?.slice(0, 6).map((course, index) => (
              <div key={index} className="group">
              <Link to={`/academia/detalle/${index}`}>
                  <div className="relative overflow-hidden rounded-lg shadow-md hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1">
                <img
                      className="w-full h-20 object-cover group-hover:scale-105 transition-transform duration-300"
                  src={getImageCourse(course.position)}
                      alt={`Curso ${course.name}`}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                    <div className="absolute bottom-0 left-0 right-0 p-2">
                      <h4 className="text-white font-medium text-xs truncate">
                        {course.name}
                      </h4>
                    </div>
                  </div>
              </Link>
            </div>
          ))}
        </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-12">
        {loading && (
          <div className="flex items-center justify-center py-20">
            <div className="flex flex-col items-center">
              <ImSpinner9 size={48} className="animate-spin text-blue-600 mb-4" />
              <p className="text-gray-600 font-medium">Cargando contenido...</p>
            </div>
          </div>
        )}


        {/*  {id && (
          <div className="grid grid-cols-6 gap-6">
            <div className="col-span-6 lg:col-span-4">
              {videos.some((v) => v.id === id) && (
                <ReactPlayer
                  url={`${process.env.REACT_APP_VIDEO}${
                    videos.find((v) => v.id === id)?.videoUrl
                  }`}
                  width="100%"
                  controls
                  onPlay={() => dispatchCounters("play", videos.find((v) => v.id === id)?.id || '')}
                  onEnded={() => dispatchCounters('ended', videos.find((v) => v.id === id)?.id || '')}
                />
              )}
              <div className="text-2xl font-bold mt-2">
                {videos.find((v) => v.id === id)?.name}
              </div>
              <div className="font-semibold">
              {videos.find((v) => v.id === id)?.views} Vistas.
              </div>
              <div className="flex items-center gap-2 mb-2">
                <img
                  src={LogoComment}
                  alt="logoISF"
                  className="w-8 rounded-full"
                />
                <div className="flex items-center justify-between w-full">
                  <span className="font-semibold">ISF OFICIAL</span>
                  <div
                    onClick={() => (!loadingLike ? handleLike(id) : null)}
                    className="flex text-xl  font-bold items-center gap-1 cursor-pointer"
                    title="Presiona para dar Like"
                  >
                    <>
                      {!loadingLike ? (
                        <>
                          <AiOutlineLike size={28} />
                          {videos.find((v) => v.id === id)?.likes}
                        </>
                      ) : (
                        <ImSpinner9 className="animate-spin" size={22} />
                      )}
                    </>
                  </div>
                </div>
              </div>
              <div
                onClick={() => setViewMore(!viewMore)}
                className="bg-stone-200 px-2 py-2 rounded-md mb-2 lg:mb-40 font-normal"
              >
                El contenido de este video es propiedad intelectual de
                www.ISFCambios.com y está protegido por leyes de derechos de
                autor.
                {viewMore && 
                  <>
                    <div>
                      <div>Uso permitido</div>
                      <ul>
                        <li>Visualización personal</li>
                        <li>Compartir en redes sociales (con atribución)</li>
                      </ul>
                      <div>Uso prohibido</div>
                      <ul>
                        <li>Modificar o editar el contenido</li>
                        <li>
                          Utilizar para fines comerciales sin permiso Derechos de
                          autor
                        </li>
                        <li>
                          www.ISFCambios.com es titular de los derechos de autor del
                          contenido
                        </li>
                      </ul>
                    </div>
                    www.ISFCambios.com se reserva el derecho de tomar medidas
                    legales contra cualquier infracción de derechos de autor
                    Información adicional <br /> Para obtener permiso para utilizar
                    el contenido, contacta con servicio al cliente <br />
                    Para obtener más información sobre nuestros términos y
                    condiciones, visita terminos-y-condiciones.
                    <ul>
                      <li>
                        El contenido de este video no es una recomendación de
                        inversión
                      </li>
                      <li>
                        El trading conlleva riesgos y no es adecuado para todos los
                        inversores
                      </li>
                      <li>
                        Consulta con un asesor financiero antes de tomar decisiones
                        de inversión.
                      </li>
                      <li>
                        Recuerda adaptar el contenido a tus necesidades específicas
                        y asegurarte de cumplir con las regulaciones y leyes
                        aplicables en tu país.
                      </li>
                    </ul>
                  </>
                }
                {!viewMore ?
                  <span className="font-bold text-base px-2 cursor-pointer" onClick={() => setViewMore(true)}>Ver más...</span>
                :
                <span className="font-bold text-base px-2 cursor-pointer" onClick={() => setViewMore(false)}>Ver menos...</span>
                }
              </div>
            </div>

            <div className="col-span-6 lg:col-span-2 relative">
              <div className="flex flex-col gap-4">

                
                {videos?.map((v, key) => (
                  <div
                    onClick={() => handleVisit(v.id)}
                    key={key.toString()}
                    className="flex flex-col gap-2 relative cursor-pointer"
                  >
                    <div className="father-prevideo cursor-pointer">
                      <img
                        src={`${process.env.REACT_APP_VIDEO}${v.photoUrl}`}
                        alt={v.name}
                        className="image-prevideo w-full cursor-pointer"
                      />
                      <div className="middle-video flex items-center justify-center">
                        <FaCirclePlay size={72} className="mx-auto" />
                      </div>
                    </div>

                    <div className="flex flex-col gap-2">
                      <div className="flex gap-3 items-start">
                        <div className="flex items-center gap-2 mb-2">
                          <img
                            src={LogoComment}
                            alt="logoISF"
                            className="w-14 rounded-full relative top-1"
                          />
                        </div>
                        <div>
                          <div className="font-semibold text-base">
                            {v.name}
                          </div>

                          <div>
                            <div className="flex justify-between items-center gap-2">
                              <div className="text-xs text-gray-500">
                                ISF OFICIAL
                              </div>
                              <div className="flex items-center gap-1">
                                <AiOutlineLike size={18} />
                                {v.likes}
                              </div>
                            </div>

                            <div className="text-xs text-gray-500">
                              {v.views} visitas
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )} */}
        {/* Content Sections */}
        {location.pathname.includes("/videos") ? (
          // Videos Page Layout
          <div className="space-y-8">
            <div className="bg-white rounded-2xl shadow-xl p-8">
              <div className="flex items-center justify-between mb-6">
                <h2 className="text-2xl font-bold text-gray-900">
                  Videos Destacados
                </h2>
                <div className="flex items-center space-x-2">
                  <div className="w-2 h-2 bg-red-500 rounded-full animate-pulse"></div>
                  <span className="text-sm text-gray-500">En vivo</span>
                </div>
              </div>
              
                              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {videos?.slice(0, 6).map((video, index) => (
                    <div 
                      key={video.id} 
                      className="group cursor-pointer"
                      onClick={() => openVideoModal(video)}
                    >
                      <div className="relative overflow-hidden rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
                        <div className="aspect-video bg-gray-200 rounded-xl overflow-hidden">
                          <video
                            className="w-full h-full object-cover"
                            poster={`${process.env.REACT_APP_VIDEO}${video?.photoUrl}`}
                            preload="none"
                          >
                            <source src={`${process.env.REACT_APP_VIDEO}${video.videoUrl}`} type="video/mp4" />
                          </video>
                          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                          <div className="absolute top-3 right-3">
                            <div className="bg-black/70 text-white px-2 py-1 rounded-full text-xs font-medium">
                              {video.views} vistas
                            </div>
                          </div>
                          <div className="absolute bottom-3 left-3 right-3">
                            <h3 className="text-white font-semibold text-sm line-clamp-2">
                              {video.name}
                            </h3>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
            </div>
          </div>
        ) : location.pathname.includes("/blog") ? (
          // Blog Page Layout
          <div className="space-y-8">
            <div className="bg-white rounded-2xl shadow-xl p-8">
              <div className="flex items-center justify-between mb-6">
                <h2 className="text-2xl font-bold text-gray-900">
                  Últimas Noticias
                </h2>
                <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                  <svg className="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                  </svg>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {blogs?.slice(0, 6).map((blog, index) => (
                  <div 
                    key={blog.id} 
                    className="group cursor-pointer"
                    onClick={() => navigate(isAuthenticated ? `/noticia/${getSlug(blog.title)}` : `/blog/${getSlug(blog.title)}`)}
                  >
                    <div className="relative overflow-hidden rounded-xl shadow-md hover:shadow-lg transition-all duration-300">
                      <div className="aspect-[4/3] bg-gray-200 rounded-xl overflow-hidden">
                        <div 
                          className="w-full h-full bg-cover bg-center bg-no-repeat group-hover:scale-105 transition-transform duration-300"
                          style={{ 
                            backgroundImage: `url(${process.env.REACT_APP_BLOG_IMAGE}${blog.photo})`
                          }}
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                        <div className="absolute bottom-0 left-0 right-0 p-4">
                          <h3 className="text-white font-semibold text-sm line-clamp-2 mb-2">
                            {blog.title}
                          </h3>
                          <div className="flex items-center justify-between text-xs text-white/80">
                            <span>ISF Oficial</span>
                            <span>{blog.createdAt ? new Date(blog.createdAt).toLocaleDateString() : ''}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ) : (
          // Default Home Layout
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            
            {/* Videos Section */}
            <div className="lg:col-span-2">
              <div className="bg-white rounded-2xl shadow-xl p-8 mb-8">
                <div className="flex items-center justify-between mb-6">
                  <h2 className="text-2xl font-bold text-gray-900">
                    Videos Destacados
                  </h2>
                  <div className="flex items-center space-x-2">
                    <div className="w-2 h-2 bg-red-500 rounded-full animate-pulse"></div>
                    <span className="text-sm text-gray-500">En vivo</span>
                  </div>
                </div>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {videos?.slice(0, 4).map((video, index) => (
                    <div 
                      key={video.id} 
                      className="group cursor-pointer"
                      onClick={() => openVideoModal(video)}
                    >
                      <div className="relative overflow-hidden rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
                        <div className="aspect-video bg-gray-200 rounded-xl overflow-hidden">
                          <video
                            className="w-full h-full object-cover"
                            poster={`${process.env.REACT_APP_VIDEO}${video?.photoUrl}`}
                            preload="none"
                          >
                            <source src={`${process.env.REACT_APP_VIDEO}${video.videoUrl}`} type="video/mp4" />
                          </video>
                          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                          <div className="absolute top-3 right-3">
                            <div className="bg-black/70 text-white px-2 py-1 rounded-full text-xs font-medium">
                              {video.views} vistas
                            </div>
                          </div>
                          <div className="absolute bottom-3 left-3 right-3">
                            <h3 className="text-white font-semibold text-sm line-clamp-2">
                              {video.name}
                            </h3>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Blog Section */}
            <div className="lg:col-span-1">
              <div className="bg-white rounded-2xl shadow-xl p-8">
                <div className="flex items-center justify-between mb-6">
                  <h2 className="text-2xl font-bold text-gray-900">
                    Últimas Noticias
                  </h2>
                  <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                    <svg className="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                    </svg>
                  </div>
                </div>
                
                <div className="space-y-6">
                  {blogs?.slice(0, 3).map((blog, index) => (
                    <div 
                      key={blog.id} 
                      className="group cursor-pointer"
                      onClick={() => navigate(isAuthenticated ? `/noticia/${getSlug(blog.title)}` : `/blog/${getSlug(blog.title)}`)}
                    >
                      <div className="relative overflow-hidden rounded-xl shadow-md hover:shadow-lg transition-all duration-300">
                        <div className="aspect-[4/3] bg-gray-200 rounded-xl overflow-hidden">
                          <div 
                            className="w-full h-full bg-cover bg-center bg-no-repeat group-hover:scale-105 transition-transform duration-300"
                            style={{ 
                              backgroundImage: `url(${process.env.REACT_APP_BLOG_IMAGE}${blog.photo})`
                            }}
                          />
                          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                          <div className="absolute bottom-0 left-0 right-0 p-4">
                            <h3 className="text-white font-semibold text-sm line-clamp-2 mb-2">
                              {blog.title}
                            </h3>
                            <div className="flex items-center justify-between text-xs text-white/80">
                              <span>ISF Oficial</span>
                              <span>{blog.createdAt ? new Date(blog.createdAt).toLocaleDateString() : ''}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
                )}

        {/* News Section - Digno de un tema - Solo visible en /blog */}
        {location.pathname.includes("/blog") && (
          <section id="news-section" className="py-16 bg-gradient-to-br from-gray-50 to-gray-100">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="text-center mb-12">
                <h2 className="text-4xl font-bold text-gray-900 mb-4">
                  Últimas Noticias
                </h2>
                <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                  Mantente informado con las últimas noticias, artículos y contenido exclusivo de nuestra plataforma
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {blogs?.map((blog, index) => (
                  <div 
                    key={blog.id} 
                    className="group cursor-pointer transform hover:scale-105 transition-all duration-300"
                    onClick={() => navigate(isAuthenticated ? `/noticia/${getSlug(blog.title)}` : `/blog/${getSlug(blog.title)}`)}
                  >
                    <article className="bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-300">
                      {/* Image */}
                      <div className="relative h-64 overflow-hidden">
                        <div 
                          className="w-full h-full bg-cover bg-center bg-no-repeat group-hover:scale-110 transition-transform duration-500"
                          style={{ 
                            backgroundImage: `url(${process.env.REACT_APP_BLOG_IMAGE}${blog.photo})`
                          }}
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                        
                        {/* Category Badge */}
                        <div className="absolute top-4 left-4">
                          <span className="bg-blue-600 text-white px-3 py-1 rounded-full text-xs font-semibold">
                            Noticias
                          </span>
                        </div>

                        {/* Date Badge */}
                        <div className="absolute top-4 right-4">
                          <div className="bg-white/90 text-gray-800 px-3 py-1 rounded-full text-xs font-medium">
                            {blog.createdAt ? new Date(blog.createdAt).toLocaleDateString('es-ES', {
                              day: 'numeric',
                              month: 'short',
                              year: 'numeric'
                            }) : ''}
                          </div>
                        </div>
                      </div>

                      {/* Content */}
                      <div className="p-6">
                        <div className="flex items-center mb-3">
                          <div className="w-8 h-8 bg-gradient-to-r from-emerald-600 to-emerald-300 rounded-full flex items-center justify-center">
                            <span className="text-white font-bold text-sm">ISF</span>
                          </div>
                          <div className="ml-3">
                            <p className="text-sm font-semibold text-gray-900">ISF Oficial</p>
                            <p className="text-xs text-gray-500">Intercambios Sin Fronteras</p>
                          </div>
                        </div>

                        <h3 className="text-xl font-bold text-gray-900 mb-3 line-clamp-2 group-hover:text-blue-600 transition-colors duration-200">
                          {blog.title}
                        </h3>

                        <div 
                          className="text-gray-600 text-sm leading-relaxed mb-4 line-clamp-3"
                          dangerouslySetInnerHTML={{ 
                            __html: getSubString(blog.content.substring(0, 150)) + '...' 
                          }}
                        />

                        {/* Read More */}
                        <div className="flex items-center justify-between">
                          <button className="text-blue-600 font-semibold text-sm hover:text-blue-800 transition-colors duration-200">
                            Leer más →
                          </button>
                          <div className="flex items-center space-x-2 text-xs text-gray-500">
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                            </svg>
                            <span>5 min lectura</span>
                          </div>
                        </div>
                      </div>
                    </article>
                  </div>
                ))}
              </div>

              {/* Load More Button */}
              {/*             <div className="text-center mt-12">
                <button className="bg-gradient-to-r from-blue-600 to-purple-600 text-black px-8 py-4 rounded-full font-semibold hover:from-blue-700 hover:to-purple-700 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1">
                  Cargar Más Noticias
                </button>
              </div> */}
            </div>
          </section>
        )}

        {/* Videos Section - Digno de un tema - Solo visible en /videos */}
        {location.pathname.includes("/videos") && (
          <section id="videos-section" className="py-16 bg-gradient-to-br from-gray-50 to-gray-100">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="text-center mb-12">
                <h2 className="text-4xl font-bold text-gray-900 mb-4">
                  Videos Educativos
                </h2>
                <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                  Descubre los mejores videos educativos y contenido audiovisual de nuestra plataforma
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {videos?.map((video, index) => (
                  <div 
                    key={video.id} 
                    className="group cursor-pointer transform hover:scale-105 transition-all duration-300"
                    onClick={() => openVideoModal(video)}
                  >
                    <article className="bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-300">
                      {/* Video Thumbnail */}
                      <div className="relative h-64 overflow-hidden">
                        <div 
                          className="w-full h-full bg-cover bg-center bg-no-repeat group-hover:scale-110 transition-transform duration-500"
                          style={{ 
                            backgroundImage: `url(${process.env.REACT_APP_VIDEO}${video.photoUrl})`
                          }}
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                        
                        {/* Play Button Overlay */}
                        <div className="absolute inset-0 flex items-center justify-center">
                          <div className="w-16 h-16 bg-white/90 rounded-full flex items-center justify-center group-hover:bg-white transition-all duration-300">
                            <svg className="w-8 h-8 text-blue-600 ml-1" fill="currentColor" viewBox="0 0 24 24">
                              <path d="M8 5v14l11-7z"/>
                            </svg>
                          </div>
                        </div>

                        {/* Category Badge */}
                        <div className="absolute top-4 left-4">
                          <span className="bg-red-600 text-white px-3 py-1 rounded-full text-xs font-semibold">
                            Video
                          </span>
                        </div>

                        {/* Views Badge */}
                        <div className="absolute top-4 right-4">
                          <div className="bg-black/70 text-white px-3 py-1 rounded-full text-xs font-medium flex items-center space-x-1">
                            <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                            </svg>
                            <span>{video.views}</span>
                          </div>
                        </div>
                      </div>

                      {/* Content */}
                      <div className="p-6">
                        <div className="flex items-center mb-3">
                          <div className="w-8 h-8 bg-gradient-to-r from-red-500 to-rose-300 rounded-full flex items-center justify-center">
                            <span className="text-white font-bold text-sm">ISF</span>
                          </div>
                          <div className="ml-3">
                            <p className="text-sm font-semibold text-gray-900">ISF Oficial</p>
                            <p className="text-xs text-gray-500">Intercambios Sin Fronteras</p>
                          </div>
                        </div>

                        <h3 className="text-xl font-bold text-gray-900 mb-3 line-clamp-2 group-hover:text-red-600 transition-colors duration-200">
                          {video.name}
                        </h3>

                        <div className="text-gray-600 text-sm leading-relaxed mb-4 line-clamp-3">
                          {video.description || "Descubre contenido educativo exclusivo de nuestra plataforma."}
                        </div>

                        {/* Video Stats */}
                        <div className="flex items-center justify-between">
                          <button className="text-red-600 font-semibold text-sm hover:text-red-800 transition-colors duration-200">
                            Ver video →
                          </button>
                          <div className="flex items-center space-x-4 text-xs text-gray-500">
                            <div className="flex items-center space-x-1">
                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                              </svg>
                              <span>{video.likes}</span>
                            </div>
                            <div className="flex items-center space-x-1">
                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                              </svg>
                              <span>{video.views} vistas</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </article>
                  </div>
                ))}
              </div>

              {/* Load More Button */}
 {/*              <div className="text-center mt-12">
                <button className="bg-gradient-to-r from-red-600 to-pink-600 text-white px-8 py-4 rounded-full font-semibold hover:from-red-700 hover:to-pink-700 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1">
                  Cargar Más Videos
                </button>
              </div> */}
            </div>
          </section>
        )}

        {/* Video Modal */}
        {isVideoModalOpen && selectedVideo && (
          <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
            <div className="relative bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[95vh] overflow-y-auto">
              {/* Close Button */}
              <button
                onClick={closeVideoModal}
                className="absolute top-4 right-4 z-10 w-10 h-10 bg-black bg-opacity-50 text-white rounded-full flex items-center justify-center hover:bg-opacity-75 transition-all duration-200"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>

              {/* Video Container */}
              <div className="relative">
                <video
                  className="w-full h-auto max-h-[50vh] bg-black"
                  controls
                  autoPlay
                  poster={`${process.env.REACT_APP_VIDEO}${selectedVideo.photoUrl}`}
                >
                  <source
                    src={`${process.env.REACT_APP_VIDEO}${selectedVideo.videoUrl}`}
                    type="video/mp4"
                  />
                  Tu navegador no soporta el elemento video.
                </video>
              </div>

              {/* Video Info */}
              <div className="p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                  {selectedVideo.name}
                </h3>
                <p className="text-gray-600 mb-4">
                  {selectedVideo.description || "Descubre contenido educativo exclusivo de nuestra plataforma."}
                </p>
                
                {/* Video Stats */}
                <div className="flex items-center justify-between text-sm text-gray-500">
                  <div className="flex items-center space-x-4">
                    <div className="flex items-center space-x-1">
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                      </svg>
                      <span>{selectedVideo.views} vistas</span>
                    </div>
                    
                    {/* Like Button */}
                    <button 
                      onClick={handleVideoLike}
                      disabled={isLikingVideo}
                      className={`flex items-center space-x-1 transition-all duration-200 ${
                        isLikingVideo 
                          ? 'text-gray-400 cursor-not-allowed' 
                          : 'text-red-600 hover:text-red-800 cursor-pointer'
                      }`}
                    >
                      {isLikingVideo ? (
                        <svg className="w-4 h-4 animate-spin" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                        </svg>
                      ) : (
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                        </svg>
                      )}
                      <span>{selectedVideo.likes} me gusta</span>
                    </button>
                  </div>
                  
                  {/* Share Button - Disabled */}
                  <button 
                    disabled
                    className="flex items-center space-x-2 text-gray-400 cursor-not-allowed opacity-60 transition-all duration-200 group"
                    title="Función no disponible"
                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.367 2.684 3 3 0 00-5.367-2.684z" />
                    </svg>
                    <span>Compartir</span>
                    <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

      </section>
    </div>
  );
};

type paramPrintVideos = {
  videoList: Video[];
};
type paramPrintBlog = {
  blogList: IBlog[];
};
const PrintVideos = ({ videoList }: paramPrintVideos) => {
  const [loadingLike, setLoadingLike] = useState<boolean>(false);
  /* const [viewMore, setViewMore] = useState<boolean>(false); */
  const [videos, setVideos] = useState<Video[]>(videoList);
  const [watched, setWatched] = useState<boolean>(false);
  const { id } = useParams();

  useEffect(() => {
    /* setViewMore(false); */
    setWatched(false);
  }, [id]);

  const handleLike = async (id: any) => {
    setLoadingLike(true);
    await APIService.videoLike({ videoId: id });
    videos?.map((v) => {
      if (v.id === id) {
        v.likes = Number(v.likes) + 1;
      }
      return v;
    });
    setLoadingLike(false);
  };

  const savePlayed = async (type: string, id:string) => {
    await APIService.videoUpdateViews({ type, videoId: id });
  };

  const dispatchCounters = (action: string, id: string) => {

      if (action === "play") {
        savePlayed("view",id);
      } else if (action === "ended") {
        savePlayed("completed",id);
      }
      setVideos(
        videos?.map((v) => {
          if (v.id === id) {
            v.views = Number(v.views) + 1;
          }
          return v;
        })
      );
  };

  return (
    <>
      {videos
      ?.sort((a:any,b:any) => Date.parse(b.createdAt) - Date.parse(a.createdAt))
      ?.map((v, key) => (
        <>
          <CardWall
            title={v.name}
            key={key.toString()}
            autor={"ISF Cambios"}
            description={v?.description}
          >
            <div>
              <video
                className="w-full bg-[#000] h-80"
                controls
                poster={`${process.env.REACT_APP_VIDEO}${v?.photoUrl}`}
                onPlay={() => dispatchCounters("play", v.id)}
              >
                <source
                  src={`${process.env.REACT_APP_VIDEO}${v.videoUrl}`}
                  type="video/mp4"
                />
                Your browser does not support the video tag.
              </video>
              <div className="flex items-center justify-between px-4 mt-2">
                <div>{v.views} vistas</div>
                <div
                  onClick={() => (!loadingLike ? handleLike(v.id) : null)}
                  className="flex cursor-pointer items-center gap-2 font-bold "
                >
                  <>
                    {!loadingLike ? (
                      <>
                        <AiOutlineLike size={28} />
                        {v.likes}
                      </>
                    ) : (
                      <ImSpinner9 className="animate-spin" size={22} />
                    )}
                  </>
                </div>
              </div>
            </div>
          </CardWall>
        </>
      ))}
    </>
  );
};

const PrintBlog = ({ blogList }: paramPrintBlog) => {
  const [blogs] = useState(blogList);
  const navigate = useNavigate();
  return (
    <div>
      {blogs
        ?.filter((_, i) => i < 3)
        ?.map((b, k) => (
          <>
            <CardWall
              title={b.title}
              key={k.toString()}
              autor={"ISF Cambios"}
              description={
                <div className="text-sm">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: getSubString(b.content.substring(0, 900)) || ""
                    }}
                  />
                  <div
                    className="cursor-pointer mt-2 font-semibold"
                    onClick={() => navigate("/blog/" + getSlug(b.title))}
                  >
                    Ver más...
                  </div>
                </div>
              }
            >
                <div 
                  className="w-full cursor-pointer bg-gray-100 rounded-lg overflow-hidden"
                  onClick={() => navigate("/blog/" + getSlug(b.title))}
                >
                  <div 
                    className="w-full aspect-[16/9] bg-cover bg-center bg-no-repeat"
                    style={{ 
                      backgroundImage: `url(${process.env.REACT_APP_BLOG_IMAGE}${b.photo})`
                    }}
                  />
                </div>
             
            </CardWall>
          </>
        ))}
    </div>
  );
};

export default NewsHomePage;
